import { render, staticRenderFns } from "./ResumeFilesCmh.vue?vue&type=template&id=24b2a5b2&scoped=true"
import script from "./ResumeFilesCmh.vue?vue&type=script&lang=ts"
export * from "./ResumeFilesCmh.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b2a5b2",
  null
  
)

export default component.exports